import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { config } from '../config/config'

import { IGroupRequestData } from '../models/group-form.model'
import { Group } from '../models/group.model'
import { User } from '../models/user.model'

export interface IGetOptions {
  userId?: string,
  name?: string
}

@Injectable()
export class GroupsService {

  constructor (private api: ApiService) {}

  async get (options: IGetOptions = {}, enableBeforeAfter = true): Promise<Group[]> {
    let query = `${config.api.url}/api/groups?`
    if (options.userId) query += `userId=${options.userId}&`
    if (options.name) query += `name=${options.name}&`

    const url = query.substring(0, query.length - 1)

    const data = await this.api.get(url, null, {enableBeforeAfter})
    return data.map(el => new Group().cast(el))
  }

  async getById (id): Promise<Group> {
    const data = await this.api.get(`${config.api.url}/api/groups/${id}`)
    return new Group().cast(data)
  }

  async put (form: IGroupRequestData): Promise<Group> {
    const data = await this.api.put(`${config.api.url}/api/groups/${form.id}`, form)
    return new Group().cast(data)
  }

  async post (form: IGroupRequestData): Promise<Group> {
    const data = await this.api.post(`${config.api.url}/api/groups`, form)
    return new Group().cast(data)
  }

  delete (groupId): Promise<Group> {
    return this.api.delete(`${config.api.url}/api/groups/${groupId}`)
  }

  async addUser (form: IGroupRequestData): Promise<Group> {
    const data = await this.api.post(`${config.api.url}/api/groups/${form.id}/users`, form)
    return new Group().cast(data)
  }

  async deleteUser (groupId: string, userId: string): Promise<Group> {
    const data = await this.api.delete(`${config.api.url}/api/groups/${groupId}/users/${userId}`)
    return new Group().cast(data)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/groups.service.ts